var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSwitchVersionHint = function SvgSwitchVersionHint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#switch-version-hint_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FEF3E2",
    d: "M29.938 30.819q.093-.423.093-.875a3.966 3.966 0 0 0-3.968-3.969 3.975 3.975 0 0 0-3.875 3.088 3.977 3.977 0 0 0-6.194.65 3.98 3.98 0 0 0-3.357-1.844A3.95 3.95 0 0 0 9.8 29.063a3.97 3.97 0 0 0-3.875-3.088 3.966 3.966 0 0 0-3.969 3.969q0 .452.094.875"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FEF3E2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M31.375 31.37H.625"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB624",
    d: "M20.05 5.1c1.119 1.913 1.637 3.856 1.594 6.031-.044 2.544-1.02 5.707-1.838 8.182h-7.519c-.818-2.475-1.806-5.644-1.837-8.182-.044-2.175.475-4.118 1.594-6.03"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB624",
    d: "M16.05 19.313h-3.769c.231.508.469 1.008.688 1.486.081.184.319.306.587.31h4.969c.275-.004.513-.126.588-.31.218-.478.456-.978.687-1.486zM13.669 21.8a1.83 1.83 0 0 0-.294.988C13.375 25.113 16 26.2 16 26.2s2.625-1.087 2.625-3.412a1.84 1.84 0 0 0-.294-.988z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD28D",
    d: "M15.112 21.8a.95.95 0 0 0-.112.45c0 1.056 1 1.55 1 1.55s1-.494 1-1.55a.96.96 0 0 0-.112-.45z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#E53838",
    d: "M12.281 19.313c-.525-1.594-1.125-3.475-1.494-5.294l-.325-.05-.625.625c-3.125 3.125-.218 8.006-.212 8.175.05.144 1.844-1.775 2.85-2.869-.062-.194-.131-.393-.194-.587m9.888-4.719-.825-.825c-.363 1.894-.988 3.875-1.538 5.544q-.103.317-.206.625c.969 1.15 2.675 3.15 2.781 2.831.006-.169 2.894-5.069-.212-8.175"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB624",
    d: "M20.05 5.1c-.069.069-.281.263-.35.338a5.23 5.23 0 0 1-3.656 1.487 5.23 5.23 0 0 1-3.657-1.487c-.068-.069-.28-.263-.35-.338.925-1.575 2.244-3.056 3.582-4.287a.6.6 0 0 1 .425-.175c.156 0 .306.062.425.175C17.806 2.044 19.112 3.53 20.05 5.1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "switch-version-hint_svg__b",
    width: 9,
    height: 7,
    x: 12,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F79B0F",
    d: "M20.05 5.1c-.069.069-.281.263-.35.338a5.23 5.23 0 0 1-3.656 1.487 5.23 5.23 0 0 1-3.657-1.487c-.068-.069-.28-.263-.35-.338.925-1.575 2.244-3.056 3.582-4.287a.6.6 0 0 1 .425-.175c.156 0 .306.062.425.175C17.806 2.044 19.112 3.53 20.05 5.1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#switch-version-hint_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E53838",
    d: "M20.05 3.1c-.069.069-.281.263-.35.338a5.23 5.23 0 0 1-3.656 1.487 5.23 5.23 0 0 1-3.657-1.487c-.068-.07-.28-.263-.35-.338.925-1.575 2.244-3.056 3.582-4.287a.6.6 0 0 1 .425-.175c.156 0 .306.062.425.175C17.806.043 19.112 1.53 20.05 3.1"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#4DA7F7",
    stroke: "#fff",
    d: "M16.044 9.569a2.213 2.213 0 1 1-.001 4.425 2.213 2.213 0 0 1 .001-4.425Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "switch-version-hint_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgSwitchVersionHint;